export default "__VITE_ASSET__CxF0DM30__"